import { render, staticRenderFns } from "./TheDataTable.vue?vue&type=template&id=7cef3dd8&scoped=true"
import script from "./TheDataTable.vue?vue&type=script&lang=js"
export * from "./TheDataTable.vue?vue&type=script&lang=js"
import style0 from "./TheDataTable.vue?vue&type=style&index=0&id=7cef3dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cef3dd8",
  null
  
)

export default component.exports